<app-loader [loading]="isLoading"></app-loader>
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>